module.exports = __webpack_public_path__ + "img/sol_cap4.dd372441.png";